let modalEl = null;
let htmxListenerBound = false;

function openVideoModal(url, title = '', text = '', talkUrl = '') {
  if (!modalEl) {
    modalEl = document.getElementById('video-modal');
  }
  if (!modalEl) {
    return;
  }
  const container = modalEl.querySelector('.gallery-modal__video');
  const titleEl = modalEl.querySelector('.gallery-modal__title');
  const descEl = modalEl.querySelector('.gallery-modal__desc');
  const ctaWrap = modalEl.querySelector('.gallery-modal__cta');
  const ctaEl = modalEl.querySelector('.gallery-modal__cta a');
  if (!container) {
    return;
  }
  container.innerHTML = '';

  if (titleEl) {
    titleEl.textContent = title || '';
  }
  if (descEl) {
    descEl.textContent = text || '';
  }
  if (ctaEl && ctaWrap) {
    if (talkUrl) {
      ctaEl.href = talkUrl;
      ctaEl.hidden = false;
      ctaWrap.hidden = false;
    } else {
      ctaEl.removeAttribute('href');
      ctaEl.hidden = true;
      ctaWrap.hidden = true;
    }
  }

  const autoplayUrl = buildYouTubeAutoplayUrl(url);
  const iframeEl = document.createElement('iframe');
  iframeEl.setAttribute('src', autoplayUrl);
  iframeEl.setAttribute('allow', 'autoplay; encrypted-media');
  iframeEl.setAttribute('allowfullscreen', '');
  iframeEl.setAttribute('title', title || 'Video');
  iframeEl.style.width = '100%';
  iframeEl.style.aspectRatio = '16 / 9';
  iframeEl.style.border = '0';
  container.appendChild(iframeEl);

  document.body.classList.add('modal-open');
  modalEl.setAttribute('aria-hidden', 'false');
}

function closeVideoModal() {
  if (!modalEl) {
    modalEl = document.getElementById('video-modal');
  }
  if (!modalEl) {
    return;
  }
  const container = modalEl.querySelector('.gallery-modal__video');
  const titleEl = modalEl.querySelector('.gallery-modal__title');
  const descEl = modalEl.querySelector('.gallery-modal__desc');
  const ctaWrap = modalEl.querySelector('.gallery-modal__cta');
  const ctaEl = modalEl.querySelector('.gallery-modal__cta a');
  if (container) {
    container.innerHTML = '';
  }
  if (titleEl) {
    titleEl.textContent = '';
  }
  if (descEl) {
    descEl.textContent = '';
  }
  if (ctaEl && ctaWrap) {
    ctaEl.removeAttribute('href');
    ctaEl.hidden = true;
    ctaWrap.hidden = true;
  }
  modalEl.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
}

function bindVideoCardClicks() {
  const cards = Array.from(document.querySelectorAll('.videos-list .video-card'));
  if (!cards.length) {
    return;
  }
  cards.forEach((card) => {
    const triggers = Array.from(card.querySelectorAll('.js-video-trigger'));
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const url = card.getAttribute('data-video-url');
        const title = card.getAttribute('data-title') || '';
        const text = card.getAttribute('data-text') || '';
        const talkUrl = card.getAttribute('data-talk-url') || '';
        if (url) {
          openVideoModal(url, title, text, talkUrl);
        }
      });
    });
  });
}

function bindModalControls() {
  if (!modalEl) {
    modalEl = document.getElementById('video-modal');
  }
  if (!modalEl) {
    return;
  }
  const overlay = modalEl.querySelector('.gallery-modal__overlay');
  const closeBtn = modalEl.querySelector('.gallery-modal__close');
  if (overlay) {
    overlay.addEventListener('click', () => closeVideoModal());
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeVideoModal());
  }
  // If any link inside the modal is clicked (e.g., Barba navigation),
  // remove body class and hide modal without interfering with navigation
  modalEl.addEventListener('click', (e) => {
    const anchor = e.target.closest('a');
    if (anchor && modalEl.contains(anchor)) {
      document.body.classList.remove('modal-open');
      modalEl.setAttribute('aria-hidden', 'true');
    }
  });
  document.addEventListener('keydown', (e) => {
    const isHidden = !modalEl || modalEl.getAttribute('aria-hidden') !== 'false';
    if (isHidden) {
      return;
    }
    if (e.key === 'Escape') {
      closeVideoModal();
    }
  });
}

function bindHtmxAfterSwapOnce() {
  if (htmxListenerBound) {
    return;
  }
  document.addEventListener('htmx:afterSwap', (evt) => {
    const target = evt.target;
    if (target && target.id === 'videos-component') {
      bindVideoCardClicks();
    }
  });
  htmxListenerBound = true;
}

function buildYouTubeAutoplayUrl(inputUrl) {
  try {
    const urlObj = new URL(inputUrl, window.location.origin);
    let videoId = '';
    if (urlObj.hostname.includes('youtu.be')) {
      videoId = urlObj.pathname.replace('/', '');
    } else if (urlObj.searchParams.get('v')) {
      videoId = urlObj.searchParams.get('v');
    } else {
      const match = inputUrl.match(/youtube\.com\/embed\/([^?&/#]+)/);
      if (match && match[1]) {
        videoId = match[1];
      }
    }
    const start = urlObj.searchParams.get('t') || urlObj.searchParams.get('start') || 0;
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1&start=${start}`;
  } catch (e) {
    const hasQuery = inputUrl.includes('?');
    const sep = hasQuery ? '&' : '?';
    return `${inputUrl}${sep}autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  }
}

export default function initVideoModal() {
  const videosComp = document.getElementById('videos-component');
  if (!videosComp) {
    return;
  }
  bindVideoCardClicks();
  bindModalControls();
  bindHtmxAfterSwapOnce();
}


